import { motion } from 'framer-motion';
import { useTranslation } from 'react-i18next';
import { animations, viewportConfig } from '../../config/animations';

const AboutHass = () => {
  const { t } = useTranslation();

  return (
    <section className='py-16 lg:py-24 bg-white'>
      <div className='container mx-auto px-4 sm:px-6 lg:px-8'>
        {/* Header */}
        <motion.div
          {...animations.fadeInUp}
          whileInView={animations.fadeInUp.animate}
          viewport={viewportConfig}
          className='text-center mb-16 lg:mb-20'
        >
          <h2 className='text-4xl sm:text-5xl lg:text-6xl font-eras font-bold text-avoprime-primary mb-6 leading-tight'>
            {t('aboutHass.title')}
          </h2>
        </motion.div>

        {/* Main Content */}
        <div className='max-w-6xl mx-auto'>
          <div className='grid lg:grid-cols-2 gap-12 lg:gap-16 items-center'>
            {/* Image */}
            <motion.div
              {...animations.fadeInLeft}
              whileInView={animations.fadeInLeft.animate}
              viewport={viewportConfig}
              className='order-1 lg:order-1'
            >
              <div className='relative'>
                <div className='aspect-square p-2 lg:p-4'>
                  <img
                    src='/avocado-info.webp'
                    alt={t('aboutHass.title')}
                    className='w-full h-full object-contain'
                  />
                </div>
              </div>
            </motion.div>

            {/* Text Content */}
            <motion.div
              {...animations.fadeInRight}
              whileInView={animations.fadeInRight.animate}
              viewport={viewportConfig}
              className='order-2 lg:order-2 space-y-8'
            >
              <div className='text-center lg:text-left'>
                <h3 className='text-2xl sm:text-3xl lg:text-4xl font-eras font-bold text-avoprime-secondary mb-6 leading-tight'>
                  {t('aboutHass.subtitle')}
                </h3>
                <p className='text-lg sm:text-xl text-gray-600 leading-relaxed'>
                  {t('aboutHass.description')}
                </p>
              </div>

              {/* Features Grid */}
              <div className='grid grid-cols-2 gap-4'>
                <div className='flex flex-col items-center text-center p-4 rounded-xl bg-gray-50/50'>
                  <div className='w-12 h-12 bg-avoprime-primary/10 rounded-full flex items-center justify-center mb-3'>
                    <div className='w-6 h-6 bg-avoprime-primary rounded-full' />
                  </div>
                  <span className='text-sm font-montserrat text-gray-700 font-medium'>
                    {t('aboutHass.feature1')}
                  </span>
                </div>
                <div className='flex flex-col items-center text-center p-4 rounded-xl bg-gray-50/50'>
                  <div className='w-12 h-12 bg-avoprime-primary/10 rounded-full flex items-center justify-center mb-3'>
                    <div className='w-6 h-6 bg-avoprime-primary rounded-full' />
                  </div>
                  <span className='text-sm font-montserrat text-gray-700 font-medium'>
                    {t('aboutHass.feature2')}
                  </span>
                </div>
                <div className='flex flex-col items-center text-center p-4 rounded-xl bg-gray-50/50'>
                  <div className='w-12 h-12 bg-avoprime-primary/10 rounded-full flex items-center justify-center mb-3'>
                    <div className='w-6 h-6 bg-avoprime-primary rounded-full' />
                  </div>
                  <span className='text-sm font-montserrat text-gray-700 font-medium'>
                    {t('aboutHass.feature3')}
                  </span>
                </div>
                <div className='flex flex-col items-center text-center p-4 rounded-xl bg-gray-50/50'>
                  <div className='w-12 h-12 bg-avoprime-primary/10 rounded-full flex items-center justify-center mb-3'>
                    <div className='w-6 h-6 bg-avoprime-primary rounded-full' />
                  </div>
                  <span className='text-sm font-montserrat text-gray-700 font-medium'>
                    {t('aboutHass.feature4')}
                  </span>
                </div>
              </div>
            </motion.div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default AboutHass;
